import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: (props) => ({
    thInputWrapper: 'relative w-full',
    thInput: 'h-full relative w-full',
    thPlaceholder: '',
    thCaret: classnames('pointer-events-none absolute end-0 top-0 flex h-full items-center', {
      'text-current': !props.isDisabled,
      'text-black': props.isDisabled,
    }),
  }),
};
